import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { ActivityEntity, ActivitySection } from '../constants/activity-log';

export interface ExportLogMeta {
  section: ActivitySection;
  projectId?: number | null;
  siteId?: number | null;
  entityType?: ActivityEntity | null;
  entityId?: number | null;
  entityLabel?: string | null;
}

const EXCEL_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor(private apiService: ApiBaseService) { }

  async getGridConnectionInfoHistoryData(payload: any): Promise<any> {
    return this.apiService.httpRequest('LoggingService/GetGridConnectionInfoHistoryData', payload, true, true);
  }

  async getProjectInfoHistoryData(payload: any): Promise<any> {
    return this.apiService.httpRequest('LoggingService/GetProjectInfoHistoryData', payload, true, true);
  }

  async getProjectTaskHistoryData(payload: any): Promise<any> {
    return this.apiService.httpRequest('LoggingService/GetProjectTaskHistoryData', payload, true, true)
  }

  async getLogs(payload: any): Promise<any> {
    return this.apiService.httpRequest('LoggingService/GetLogs', payload, true, true)
  }

  async logExport(formData: FormData): Promise<any> {
    return this.apiService.httpRequestForm('LoggingService/LogExport', formData, true, false);
  }

  async getExportFileLinks(payload: any): Promise<any> {
    return this.apiService.httpRequest('LoggingService/GetExportFileLinks', payload, true, true);
  }

  // Fire-and-forget: an audit-log failure must never break the user's download.
  logFileExport(file: Blob | ArrayBuffer, filename: string, meta: ExportLogMeta): void {
    try {
      const blob = file instanceof Blob ? file : new Blob([file], { type: EXCEL_MIME_TYPE });

      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          section: meta.section,
          projectId: meta.projectId ?? null,
          siteId: meta.siteId ?? null,
          entityType: meta.entityType ?? null,
          entityId: meta.entityId ?? null,
          entityLabel: meta.entityLabel ?? null,
        })
      );
      formData.append('exportFile', blob, filename);

      this.logExport(formData).catch(() => {});
    } catch (error) {}
  }


}
